import React from 'react';
import PropTypes from 'prop-types';
import Charts from './Charts';

const QuadChart = ({
  chartColor,
  chartTitle,
  xAxisName,
  yAxisName,
  data,
  dataLabelFormatter,
  clickEvent,
  xAxisLine,
  yAxisLine,
  minMaxTick,
}) => {
  const config = {
    chart: {
      type: 'bubble',
      plotBorderWidth: 1,
      zoomType: 'xy',
      backgroundColor: '#ffffff',
      style: {
        fontFamily: 'Open Sans, sans-serif',
      },
      plotBorderColor: '#ccd4e0',
    },
    title: {
      text: chartTitle,
    },
    colors: chartColor,
    legend: {
      enabled: false,
    },
    xAxis: {
      gridLineWidth: 1,
      gridLineDashStyle: 'shortdash',
      gridLineColor: '#ccd4e0',
      lineColor: '#ccd4e0',
      title: {
        text: xAxisName,
        style: {
          fontSize: '12px',
          color: '#30435d',
        },
      },
      labels: {
        format: '{value}',
        style: {
          fontSize: '8px',
          color: '#30435d',
        },
      },
      plotLines: xAxisLine,
      ...minMaxTick,
    },

    yAxis: {
      startOnTick: false,
      endOnTick: false,
      gridLineDashStyle: 'shortdash',
      gridLineColor: '#ccd4e0',
      lineColor: '#ccd4e0',
      title: {
        text: yAxisName,
        style: {
          fontSize: '12px',
          color: '#30435d',
        },
      },
      labels: {
        format: '{value}',
        style: {
          fontSize: '8px',
          color: '#30435d',
        },
      },
      maxPadding: 0.2,
      plotLines: yAxisLine,
      ...minMaxTick,
    },
    tooltip: {
      useHTML: true,
      headerFormat: '<b><span>{point.key}</span></b><br />',
      pointFormat: `${xAxisName} (Index={point.x}) <br />${yAxisName} (Index={point.y})`,
      backgroundColor: '#ffffff',
      style: {
        color: 'RGB(145, 162, 185)',
      },
    },
    plotOptions: {
      bubble: {
        minSize: 10,
        maxSize: 10,
        dataLabels: {
          allowOverlap: true,
        },
      },
      series: {
        pointStart: 0,
        pointInterval: 20,
        cursor: 'pointer',
        stickyTracking: false,
        dataLabels: {
          enabled: true,
          // format: '{y}',
          formatter: dataLabelFormatter,
          // useHTML: true,
          shape: 'callout',
          // backgroundColor: 'rgba(0, 0, 0, 0.75)',
          // borderRadius: 20,
          y: 15,
          style: {
            color: '#000000',
            textOutline: 'none',
          },
          events: {
            click: clickEvent,
          },
          // formatter: dataLabelFormatter,
        },
      },
    },
    series: [
      {
        data,
      },
    ],
  };
  return <Charts config={config} />;
};

QuadChart.propTypes = {
  chartTitle: PropTypes.string,
  chartColor: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.arrayOf(PropTypes.shape({})),
  chartLegend: PropTypes.shape({}),
  xAxisName: PropTypes.string,
  yAxisName: PropTypes.string,
};

QuadChart.defaultProps = {
  chartColor: ['#e5cf8e'],
  chartTitle: '',
  alignTitle: 'top',
  xAxisName: '',
  yAxisName: '',
};

export default QuadChart;
